<!-- 项目文件 -->
<template>
  <div class=" w100p h100p " v-show="onShow==1">
    <div v-swiper:mySwiper="swiperOption" class="posfix w100p h100p  left0 top0 zindex-1 zoom1 indexbg">
      <div class="swiper-wrapper swiper-no-swiping">
        <div class="swiper-slide" >
          <img class="w100p h100p" src="../../public/img/banner1.png">
        </div>
        <div class="swiper-slide">
          <img class="w100p h100p" src="../../public/img/banner2.png">
        </div>
      </div>
    </div>
    <div class="posab left100 top50">
      <img style="width: 196px;height: 50px;" src="../../public/img/img1.png">
    </div>
    <div class="posab right100 top50">
      <p>
        <a  class="alit" target="_blank" href="http://jiaxiao.yixueyijia.com/">
          <span class="fs14 cfff pr6">驾校后台登录</span>
          <img class="w14 h14" src="../../public/img/img117.png">
        </a>
      </p>
    </div>
    <div class="posab w100p bottom200 textc">
        <div class="disinblock mr20 ml20"> 
          <router-link to="School" tag="a" target="_blank">
            <p class="disinblock zindex999 bg1f8  pt10 pb10 bradius8 w180">
              <span class="alit textc txtc">
                <img class="w15 h16" src="../../public/img/img2.png">
                <i class="cfff pl5 fs16">我是驾校</i>
              </span>
            </p>
          </router-link>
        </div>
        <div class="disinblock mr20 ml20"> 
          <router-link to="Carhome" tag="a" target="_blank">
            <p class="disinblock zindex999 bg1f8  pt10 pb10 bradius8 w180">
              <span class="alit textc txtc">
                <img class="w15 h18" src="../../public/img/img3.png">
                <i class="cfff pl5 fs16">我是学员</i>
              </span>
            </p>
          
          </router-link>
        </div>
        <div class="disinblock mr20 ml20"> 
          <router-link to="Cooperation"  tag="a" target="_blank">
            <p class="disinblock zindex999 bg1f8  pt10 pb10 bradius8 w180">
              <span class="alit textc txtc">
                <img class="w18 h18" src="../../public/img/img4.png">
                <i class="cfff pl5 fs16">合作伙伴</i>
              </span>
            </p>
          </router-link>
        </div>
    </div>
    <div class="w100p bottom0 posab textc c666 fs14 bgfff h100 disflex align">
      <div class="w100p">
          <ul class="w100p mb10 fs12">
            <router-link to="Aboutwe">
              <li class="disinblock mr10 ml10 ">关于我们</li>|
            </router-link>
            <router-link to="AboutNews">
                <li class="disinblock mr10 ml10 ">新闻动态</li>|
            </router-link>
            <router-link to="Recruitment">
              <li class="disinblock mr10 ml10 ">诚征英才</li>|
            </router-link>
            <router-link to="Contact">
              <li class="disinblock mr10 ml10">联系我们</li>
            </router-link>
            
          </ul>
          <p class="w100p mt10 fs12 mb10">
			  <span>江苏车里车外信息技术有限公司版权所有  </span>
			  <a target="_blank" class="fs12 c333 disinblock" href="https://beian.miit.gov.cn/">苏ICP备16034047号</a>
		  </p>
          <div class="textc mt10 mb10   alit flexc ">
            <a target="_blank" class="fs12 c333 disinblock" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010502010365">
              <span class="  alit flexc ">
                <img src="../../public/img/beian.png" class="w20 h20" />
                <span class="disinblock pl10 c333">苏公网安备 32010502010365号</span>
              </span>
            </a>
            <span class="disinblock pl10   fs12 c333">
              电信经营许可证编号：苏B2-20160598
            </span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
    import $ from "jquery";
    export default {
        data() {
            return {
                onShow: 0,
                swiperOption: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    loop: true,
                    speed: 3000,
                    effect: 'fade', //动画效果：渐变
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false
                    },
                    autoplay: 2000,
                    autoplayDisableOnInteraction: false,
                    // onAutoplayStart: true
                }
            }
        },

        methods: {

        },
        beforeCreate() {
            this.flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            if (this.flag) {
                var url = 'https://m.yixueyijia.com/school_wap/head/index.html#/'
                window.location = url
            }

        },
        created() {
            let that = this;
            setTimeout(() => {
                that.onShow = 1
            }, 500);
        },
        mounted() {

        },

    }
</script>
<style scoped>
    .swiper-container {
        position: fixed;
        z-index: -1;
    }
    
    .txtc {
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>